/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {formatMoney, openNotice} from '../../utils/index.js';
import {getDelivery, fetchChannelList, idDelete, getOrderDetails} from '../../service/order';
import moment from 'moment';
import {Store, Actions} from './store';
import {objectSerial, config} from 'Utils';
import {getGouXiaoUnitList} from "../../service/traceOrder";

class SearchDelivery extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelName = this.props.location.query.channelName || '';
        this.customerManagementId = this.props.location.query.customerManagementId ? parseInt(this.props.location.query.customerManagementId, 10) : '';
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['发货管理'],
            key: 0,
            rows: [],
            total: 1,
            sum_mon: 0,
            searchObj: {
                itemNum: '',
                orderedDateBegin: moment().add(-1, 'y').format('YYYY-MM-DD'),
                orderedDateEnd: moment().add(1, 'days').format('YYYY-MM-DD'),
                comments: '',
                id: '',
                s: 10,
                p: 1,
            },
            channel_type: [], /* 渠道类型 */
            regionOptions: [], /* 所属区域 */
            loading: false,
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.exportChange = this.exportChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    goView(url) {
        hashHistory.push(url);
    }

    /*筛选重置*/
    advanceReset() {
        let self = this;
        this.setState({
            key: 0,
            searchObj: {
                ...this.state.searchObj,
                comments: '',
                itemNum: '',
                orderedDateBegin: '',
                orderedDateEnd: '',
                id: '',
                p: 1,
                channelCode: ''
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        // if (!this.state.searchObj.orderedDateBegin || this.state.searchObj.orderedDateBegin == '') {
        //     openNotice('warning', '请选择日期范围后再做查询');
        //     return;
        // }
        // if (!this.state.searchObj.orderedDateEnd || this.state.searchObj.orderedDateEnd == '') {
        //     openNotice('warning', '请选择日期范围后再做查询');
        //     return;
        // }
        if (!this.state.searchObj.id || this.state.searchObj.id == '') {
            openNotice('warning', '请选择状态后再做查询');
            return;
        }
        this.setState({
            key: this.state.searchObj.orderStatus,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'BOOKED_DATE') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderedDateBegin: value.from,
                    orderedDateEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*翻页*/
    pageChange(page, s) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        console.log(this.state.userData.roleCode);
        let self = this;
        let searchObj = this.state.searchObj;
        self.setState({
            loading: true
        })
        searchObj.orderStatus = searchObj.orderStatus == 0 ? '' : searchObj.orderStatus;
        getDelivery(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false,
                    'sum_mon': result.data[0] ? result.data[0]['SUM_MON'] : 0
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'order') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.orderStatus
            });
        }
    }

    componentDidMount() {
        let self = this;
        //this.initData();
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                // let arr = [
                //     {
                //         text: '全部',
                //         value: ''
                //     }
                // ];
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    /*返回*/
    backTo() {
        window.history.go(-1);
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/orderReport/deliveryExportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        const {opts, key, rows, total, searchObj, channel_type, loading, gouxiaoUnitList, userData} = this.state;
        const advanceProps = {
            fileds: [

                {
                    name: 'BOOKED_DATE',//orderedDateBegin, orderedDateEnd
                    label: '发运日期查询',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderedDateBegin || '',
                        end: searchObj.orderedDateEnd || ''
                    },
                },
                {
                    name: 'id',
                    label: '状态',
                    options: [{"text": "已发运", "value": "1"}, {"text": "正在发运", "value": "2"}],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.id
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                },
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                },
                {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    defaultValue: searchObj.salesUnitId,
                    showSearch: true,
                    options: gouxiaoUnitList,
                },
                {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.channel
                },
                {
                    name: 'comments',
                    label: '头备注',
                    text: '输入头备注',
                    type: 'default',
                    defaultValue: searchObj.comments
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                // {
                //     title: '渠道',
                //     dataIndex: 'SALES_CHANNEL'
                // },
                {
                    title: '订单编号',
                    dataIndex: 'ORDER_NUMBER'
                },
                {
                    title: '出库单号',
                    dataIndex: 'DELIVERY_ID'
                },
                {
                    title: '登记日期',
                    dataIndex: 'BOOKED_DATE',
                    render: text => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '发运日期',
                    dataIndex: 'SHIP_DATE',
                    render: text => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '购货单位',
                    dataIndex: 'SALES_UNIT_NAME'
                },
                {
                    title: '终端单位',
                    dataIndex: 'ATTRIBUTE11'
                },
                {
                    title: '盘厂客户',
                    dataIndex: 'PC_CUST'
                },
                {
                    title: '业务员',
                    dataIndex: 'USERNAME'
                },
                {
                    title: '提货组织',
                    dataIndex: 'ORGANIZATION_NAME'
                },
                {
                    title: '实际收货地址',
                    dataIndex: 'STANDBYADDRESS'
                },
                {
                    title: '物料编码',
                    dataIndex: 'ITEM_NUM',
                    width: 120
                },
                {
                    title: '物料描述',
                    dataIndex: 'ITEM_DESC'
                },
                {
                    title: '物料中类',
                    dataIndex: 'MAIN_CAT'
                },
                {
                    title: '发运数量',
                    dataIndex: 'QTY'
                },
                {
                    title: '牌价',
                    dataIndex: 'UNIT_LIST_PRICE',
                    render: (text, record, index) => {
                        if (userData.roleCode == 'CUSTOMER_INQUIRY') {
                            return (<span>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '销售单价',
                    dataIndex: 'UNIT_PRICE',
                    render: (text, record, index) => {
                        if (userData.roleCode == 'CUSTOMER_INQUIRY') {
                            return (<span>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '销售金额',
                    dataIndex: 'MON',
                    render: (text, record, index) => {
                        if (userData.roleCode == 'CUSTOMER_INQUIRY') {
                            return (<span>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '开单折扣率',
                    dataIndex: 'DISCOUNT_RATE',
                    render: (text, record, index) => {
                        if (userData.roleCode == 'CUSTOMER_INQUIRY') {
                            return (<span>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '折扣金额',
                    dataIndex: 'DISCOUNT_MON',
                    render: (text, record, index) => {
                        if (userData.roleCode == 'CUSTOMER_INQUIRY') {
                            return (<span>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '生产周期',
                    dataIndex: 'PROD_CYCLE'
                },
                {
                    title: '收货日期',
                    dataIndex: 'RECEIPT_DATE',
                    render: text => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '头备注',
                    dataIndex: 'COMMENTS'
                },
                {
                    title: '行备注',
                    dataIndex: 'ATTRIBUTE12'
                },
                {
                    title: '状态',
                    dataIndex: 'STATUS'
                },
            ],
            rows
        };
        let self = this;
        let backHide = (customerManagementId) => {
            if (customerManagementId) {
                return <Button onClick={self.backTo.bind(self)}>返回</Button>
            } else {
                return '';
            }
        }
        return <div>
            <DmsTab options={opts} defaultKey={0}>
                {backHide(this.customerManagementId)}
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head" style={{padding: '8px 8px 8px 0'}}>
                    <span>汇总金额：{this.state.sum_mon}<font size={1}
                                                             style={{color: 'red'}}>（默认显示一年，如需查历史数据，请重新选择日期)</font></span>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

//使用高阶组件withRouter来封装OrderList。目的是将router对象暴露出来
export default withRouter(SearchDelivery);


// WEBPACK FOOTER //
// ./src/routes/searchDelivery/list.js